import { useState, useEffect } from 'react';

const ResponsiveMusicGallery = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Sample images - replace with your actual image data
  // const images = [
  //   {
  //     id: 1,
  //     src: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=400&h=400&fit=crop",
  //     alt: "Electric Guitar",
  //     color: "bg-blue-600"
  //   },
  //   {
  //     id: 2,
  //     src: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400&h=400&fit=crop",
  //     alt: "Sunset Music",
  //     color: "bg-teal-500"
  //   },
  //   {
  //     id: 3,
  //     src: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop",
  //     alt: "White Guitar",
  //     color: "bg-green-500"
  //   },
  //   {
  //     id: 4,
  //     src: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=400&fit=crop",
  //     alt: "Guitarist Silhouette",
  //     color: "bg-orange-600"
  //   },
  //   {
  //     id: 5,
  //     src: "https://images.unsplash.com/photo-1614149162883-504ce4d13909?w=400&h=400&fit=crop",
  //     alt: "Colorful Dots",
  //     color: "bg-yellow-500"
  //   },
  //   {
  //     id: 6,
  //     src: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=400&h=400&fit=crop",
  //     alt: "Vintage Setup",
  //     color: "bg-orange-500"
  //   },
  //   {
  //     id: 7,
  //     src: "https://images.unsplash.com/photo-1518609878373-06d740f60d8b?w=400&h=400&fit=crop",
  //     alt: "Electric Guitar Black",
  //     color: "bg-gray-200"
  //   },
  //   {
  //     id: 8,
  //     src: "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=400&h=400&fit=crop",
  //     alt: "Cassette Tape",
  //     color: "bg-gray-300"
  //   },
  //   {
  //     id: 9,
  //     src: "https://images.unsplash.com/photo-1511735111819-9a3f7709049c?w=400&h=400&fit=crop",
  //     alt: "Basketball",
  //     color: "bg-red-600"
  //   },
  //   {
  //     id: 10,
  //     src: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop",
  //     alt: "Concert Performance",
  //     color: "bg-lime-400"
  //   }
  // ];

  // Split images for desktop layout
  // const leftImages = images.slice(0, 5);
  // const rightImages = images.slice(5, 10);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // const ImageCard = ({ image, className = "" }) => (
  //   <div 
  //     className={`relative group cursor-pointer rounded-xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-white/10 ${className}`}
  //     style={{ aspectRatio: '1/1' }}
  //   >
  //     <div className={`absolute inset-0 ${image.color} opacity-20 group-hover:opacity-30 transition-opacity duration-300`}></div>
  //     <img
  //       src={image.src}
  //       alt={image.alt}
  //       className="w-full h-full object-cover"
  //       loading="lazy"
  //     />
  //     <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
  //   </div>
  // );

  return (
    <div className=" bg-black p-4 md:p-8">
      <div className="max-w-6xl mx-auto">
        {isMobile ? (
          // Mobile Layout - All 10 images in a responsive grid
          <div className="">
            <img  className="w-full h-full object-cover" src='https://rummy-assets.jungleerummy.com/Content/versioned/2.0.0.1/images/version4/promotion_june_25/zenrik_images/ten-17512244658171.webp?v=1751224467'/>
            {/* {images.map((image, index) => (
              <ImageCard 
                key={image.id} 
                image={image}
                className={`
                  ${index === 0 ? 'col-span-2 sm:col-span-1' : ''}
                  ${index === 4 ? 'sm:col-span-2' : ''}
                  ${index === 7 ? 'col-span-2 sm:col-span-1' : ''}
                `}
              />
            ))} */}
          </div>
        ) : (
          // Desktop Layout - Split into left and right columns
          <div className="grid grid-cols-2 gap-8 lg:gap-12">
            {/* Left Column */}
            <div className="">
                <img className="w-full h-full object-cover" src='https://rummy-assets.jungleerummy.com/Content/versioned/2.0.0.1/images/version4/promotion_june_25/zenrik_images/photos-left-(1)-17512245273790.webp?v=1751224528'/>
              {/* {leftImages.map((image, index) => (
                <ImageCard 
                  key={image.id} 
                  image={image}
                  className={`
                    ${index === 0 ? 'col-span-2' : ''}
                    ${index === 3 ? 'col-span-2' : ''}
                  `}
                />
              ))} */}
            </div>

            {/* Right Column */}
            <div className="">
              {/* {rightImages.map((image, index) => (
                <ImageCard 
                  key={image.id} 
                  image={image}
                  className={`
                    ${index === 1 ? 'col-span-2' : ''}
                    ${index === 4 ? 'col-span-2' : ''}
                  `}
                />
              ))} */}
                <img className="w-full h-full object-cover" src='https://rummy-assets.jungleerummy.com/Content/versioned/2.0.0.1/images/version4/promotion_june_25/zenrik_images/photos-right-(2)-17512245353739.webp?v=1751224536'/>

            </div>
          </div>
        )}
      </div>

     
    </div>
  );
};

export default ResponsiveMusicGallery;